<button app-button buttonType="flat" buttonTheme="light" [matMenuTriggerFor]="baseMenu">
  <span class="hide-sm">
    {{ selectionLabel }}
  </span>

  <span class="show-sm">
    Filter
  </span>

  <fa-icon icon="caret-down" class="ml-1"></fa-icon>
</button>

<mat-menu #baseMenu="matMenu">
  <button mat-menu-item (click)="handleClickPrivate()">My models</button>

  <!-- organziation menu -->
  <div *ngIf="organization$ | async as organization" [ngSwitch]="(collections$ | async)?.length">
    <!-- no collections -->
    <button mat-menu-item (click)="handleClickOrganization(organization)" *ngSwitchCase="0">
        Team models
    </button>
    <!-- collections -->
    <button mat-menu-item [matMenuTriggerFor]="collectionMenu" *ngSwitchDefault>
        Team models
    </button>
  </div>

</mat-menu>

<mat-menu #collectionMenu="matMenu">
  <!-- organization: with collections -->
  <div *ngIf="collections$ | async as collections">
    <button 
      mat-menu-item 
      *ngIf="organization$ | async as organization"
      (click)="handleClickOrganization(organization)">All</button>
    <button 
      mat-menu-item 
      (click)="handleClickCollection(collection)"
      *ngFor="let collection of collections">{{ collection.collection_name }}</button>
  </div>
</mat-menu>
